<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Temporary
      Solution</a>
    <FormTemporarySolution v-model="data" @submit="onSubmit" ref="formTemporarySolution" />
  </main>
</template>
<script>
import axios from '@/axios';
import FormTemporarySolution from "@/components/form/feedback/temporary-solution";
import { showErrorMessage } from '@/utils';
import { objectToFormData } from '@/utils/formdata';
import structuredClone from 'core-js/actual/structured-clone';

export default {
  components: {
    FormTemporarySolution
  },
  data() {
    return {
      data: {
        tmp_solution: '',
        attachment_solution: null,
      },
    }
  },
  async created() {
    if (this.$route.name === 'FeedbackFormEditTemporarySolution') {
      await this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
      if (!['temporary_solution', 'waiting_approval', 'revision'].includes(this.detail?.status?.value)) {
        this.$router.push(`/feedback/${this.$route.params.id}`)
      }
      this.data.attachment_solution = this.detail.attachment_solution
      this.data.tmp_solution = this.detail.tmp_solution
    }
  },
  computed: {
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formTemporarySolution.$validator.validateAll();
      if (isValid) {
        try {
          this.$store.dispatch('toggleLoadingProgress', true)
          let cloneData = structuredClone(this.data);
          if (typeof cloneData.attachment_solution === 'string') {
            delete cloneData.attachment_solution;
          }

          const data = objectToFormData(cloneData);
          await axios.post(`/fnc/${this.$route.params.id}/temporary-solution`, data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          this.$notify({ type: 'success', text: 'Success updating temporary solution' })
          this.$router.push(`/feedback/${this.$route.params.id}`)
        } catch (error) {
          showErrorMessage(error)
        } finally {
          this.$store.dispatch('toggleLoadingProgress', false)
        }
      }
    },
  }
}
</script>

<style></style>
